(function () {
  if (window.__cartRecDiscountInfoInit) return;

  window.__cartRecDiscountInfoInit = true;

  var cache = {};

  function loadDiscount(card) {
    var container = card.querySelector(
      '.js-cart-rec-discount-info'
    );

    if (
      !container ||
      container.dataset.loaded ||
      container.dataset.loading
    ) {
      return;
    }

    var productLink = card.querySelector('[product-card-link]');
    var href = productLink && productLink.getAttribute('href');

    // Product card is not ready yet
    if (!href || href === '#') return;

    var productUrl = href.split('?')[0];

    container.dataset.loading = 'true';

    // Use cached content
    if (cache[productUrl] !== undefined) {
      renderDiscount(container, cache[productUrl]);

      container.dataset.loaded = 'true';
      delete container.dataset.loading;

      return;
    }

    fetch(productUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        var discountBlock = doc.querySelector(
          '.discount-info-block:not(.js-cart-rec-discount-info)'
        );

        var content = discountBlock
          ? discountBlock.innerHTML
          : '';

        cache[productUrl] = content;

        renderDiscount(container, content);

        container.dataset.loaded = 'true';
        delete container.dataset.loading;
      })
      .catch(function () {
        delete container.dataset.loading;
      });
  }

  function renderDiscount(container, content) {
    if (!content) return;

    container.innerHTML = content;
    container.hidden = false;
  }

  function checkRecommendations() {
    document
      .querySelectorAll(
        'cart-recommendations product-card-mini'
      )
      .forEach(function (card) {
        loadDiscount(card);
      });
  }

  function init() {
    // Check existing recommendations
    checkRecommendations();

    // Check after cart updates
    document.addEventListener(
      'product-card:rendered',
      checkRecommendations
    );

    // Small observer only for dynamically added cart content
    var cart = document.querySelector('interactive-cart');

    if (!cart) return;

    var observer = new MutationObserver(function () {
      checkRecommendations();
    });

    observer.observe(cart, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// (function () {
//   if (window.__cartRecDiscountInfoInit) return;

//   window.__cartRecDiscountInfoInit = true;

//   var cache = {};

//   function loadDiscount(card) {
//     if (!card || !card.closest('cart-recommendations')) return;

//     var container = card.querySelector('.js-cart-rec-discount-info');

//     if (!container || container.dataset.loaded) return;

//     var productLink = card.querySelector('[product-card-link]');

//     if (!productLink) return;

//     var productUrl = productLink.href.split('?')[0];

//     if (!productUrl) return;

//     container.dataset.loaded = 'true';

//     if (cache[productUrl] !== undefined) {
//       renderDiscount(container, cache[productUrl]);
//       return;
//     }

//     fetch(productUrl)
//       .then(function (response) {
//         if (!response.ok) {
//           throw new Error('Failed to load product');
//         }

//         return response.text();
//       })
//       .then(function (html) {
//         var doc = new DOMParser().parseFromString(
//           html,
//           'text/html'
//         );

//         var discountBlock = doc.querySelector(
//           '.discount-info-block:not(.js-cart-rec-discount-info)'
//         );

//         var content = discountBlock
//           ? discountBlock.innerHTML
//           : '';

//         cache[productUrl] = content;

//         renderDiscount(container, content);
//       })
//       .catch(function () {
//         container.dataset.loaded = '';
//       });
//   }

//   function renderDiscount(container, content) {
//     if (!content) return;

//     container.innerHTML = content;
//     container.hidden = false;
//     container.removeAttribute('hidden');
//   }

//   function loadAllDiscounts() {
//     var cards = document.querySelectorAll(
//       'cart-recommendations product-card-mini, cart-recommendations product-card'
//     );

//     cards.forEach(function (card) {
//       loadDiscount(card);
//     });
//   }

//   function init() {
//     loadAllDiscounts();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   window.addEventListener('load', loadAllDiscounts);

//   document.addEventListener('product-card:rendered', function (event) {
//     loadDiscount(event.target);
//   });
// })();